export const widgetMetaContext = 'widgetMeta';
